import Backdrop from '@material-ui/core/Backdrop';
import CircularProgress from '@material-ui/core/CircularProgress';
import makeStyles from '@material-ui/core/styles/makeStyles';
import clsx from 'clsx';
import React from 'react';

const useStyles = makeStyles((theme) => ({
  root: {
    zIndex: theme.zIndex.tooltip + 50,
    color: theme.palette.primary.main,
    backgroundColor: theme.palette.action.light,
  },
  absolute: {
    position: 'absolute',
  },
}));

export default function Loader({ open = false, fixed = false, size = 40 }) {
  const styles = useStyles();

  return (
    <Backdrop className={clsx(styles.root, !fixed && styles.absolute)} open={open}>
      <CircularProgress size={size} color="inherit" />
    </Backdrop>
  );
}
